import { render, staticRenderFns } from "./OpenCreditCardVPBank.vue?vue&type=template&id=394ced22&scoped=true&"
import script from "./OpenCreditCardVPBank.vue?vue&type=script&lang=js&"
export * from "./OpenCreditCardVPBank.vue?vue&type=script&lang=js&"
import style0 from "./OpenCreditCardVPBank.vue?vue&type=style&index=0&id=394ced22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ced22",
  null
  
)

export default component.exports